import { render, staticRenderFns } from "./AsyncImage.vue?vue&type=template&id=2ca6a7eb&scoped=true"
import script from "./AsyncImage.vue?vue&type=script&lang=js"
export * from "./AsyncImage.vue?vue&type=script&lang=js"
import style0 from "./AsyncImage.vue?vue&type=style&index=0&id=2ca6a7eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca6a7eb",
  null
  
)

export default component.exports